$(document).ready(function() {
    //Header Location Widget
    var DTL_Pincode = window.sessionStorage.getItem("DTL_pin");
    if (DTL_Pincode) {
        $('.h_location #usr_location').html(DTL_Pincode);
        $('.mob_location p').html('Delivering to '+DTL_Pincode);
        $('.h_location #usr_location, .mob_location p').attr('data-location', DTL_Pincode);
    } else {
        //window.sessionStorage.setItem("DTL_pin", '560034');
        //$('.h_location #usr_location').html('560034');
        //$('.h_location #usr_location, .mob_location p').attr('data-location', '560034');

        //$('.mob_location p').html('Delivering to 560034');
    }
//Header Location Widget Ends
//})


  //$(document).ready(function(){

    function closeSort(){
      $("#sort-dropdown").removeClass("active").removeAttr("style");
      $(".sort-overlay").removeClass("active");
      $("body").removeClass("sort-open");
      $("body").removeClass("OVH_sort");
    }

    /* ===== SORT TOGGLE ===== */
    $(document).on("click", ".pill-sort", function(e){
      e.stopPropagation();
      var dropdown = $("#sort-dropdown");
      // ===== MOBILE =====
      if ($(window).width() <= 767) {
        $("#sort-dropdown").addClass("active");
        $(".sort-overlay").addClass("active");
        $("body").addClass("sort-open");
        $("body").addClass("OVH_sort");
        return;
      }
      // ===== DESKTOP =====
      if (dropdown.is(":visible")) {
        closeSort();
        return;
      }
      var rect = this.getBoundingClientRect();
        dropdown.css({
          position: "fixed",
          top: rect.bottom + 8 + "px",
          left: rect.left + "px"
        }).show();

    });

    /* ===== OUTSIDE CLICK (DESKTOP ONLY) ===== */
    $(document).on("click", function(e){
      if ($(window).width() > 767) {
        if (!$(e.target).closest("#sort-dropdown, .pill-sort").length) {
          closeSort();
          
        }
      }
    });

    /* ===== CLOSE ON SCROLL (DESKTOP ONLY) ===== */
    $(window).on("scroll", function(){
      if ($(window).width() > 767) {
        closeSort();
      }
    });

    /* ===== CLOSE BUTTON + OVERLAY ===== */
    $(document).on("click", ".close-sort, .sort-overlay", closeSort);

    /* ===== CLOSE AFTER FILTER / SORT CHANGE ===== */
    $(document).on("change", ".mobile-facets__checkbox, .facets__checkbox", function(){
      closeSort();
    });

    /* ===== LOADER ===== */
    $(document).on("click", ".mobile-facets__checkbox, .facets__checkbox", function(){
      $(".PLP_filter_loader").addClass("active");

      setTimeout(function(){
        $(".PLP_filter_loader").removeClass("active");
      }, 5000);
    });

    /* ===== AUTO CLOSE AFTER AJAX RELOAD ===== */
    $(document).ajaxComplete(function(){
      closeSort();
    });

  });